import React, { createContext, useContext } from 'react';

interface CurationModeContextValue {
  curationMode: boolean;
}

const CurationModeContext = createContext<CurationModeContextValue>({
  curationMode: false,
});

export const CurationModeProvider: React.FC<{
  curationMode: boolean;
  children: React.ReactNode;
}> = ({ curationMode, children }) => {
  return (
    <CurationModeContext.Provider value={{ curationMode }}>
      {children}
    </CurationModeContext.Provider>
  );
};

export const useCurationMode = () => useContext(CurationModeContext);

export default CurationModeContext;
